import { render, staticRenderFns } from "./plan.vue?vue&type=template&id=28ef8ada&scoped=true"
import script from "./plan.vue?vue&type=script&lang=js"
export * from "./plan.vue?vue&type=script&lang=js"
import style0 from "./plan.vue?vue&type=style&index=0&id=28ef8ada&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ef8ada",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28ef8ada')) {
      api.createRecord('28ef8ada', component.options)
    } else {
      api.reload('28ef8ada', component.options)
    }
    module.hot.accept("./plan.vue?vue&type=template&id=28ef8ada&scoped=true", function () {
      api.rerender('28ef8ada', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hr/training/plan.vue"
export default component.exports